import React from 'react';
import TagesberichtComponent from "../Tagesbericht/Tagesbericht";

const AppWebReportTagesberichtPage = (props) => {
    return (
        <>
        <TagesberichtComponent
            tageState={"Akzeptiert"}
            reportView={false}
            reportViewWithoutLogin={true}
            details={props.reportData.tagesdata}
            pdfAddress = {props.reportData.pdfAddress}
        /></>
    )
}

export default AppWebReportTagesberichtPage;